<template>
    <div class='visual-pointer'>
        <svg class="visual-pointer__svg-canvas"
             :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid slice"
        >
            <template v-for="(pointer, index) in pointers">
                <svg
                    :key=index
                    :x="[pointer.left ? pointer.left : 0]"
                    :y="[pointer.top ? pointer.top : 0]"
                    ref="anchor"
                ></svg>
            </template>
        </svg>
        <template v-for="(pointer, index) in pointers">
            <div
                v-if="pointer && pointer.reposition.top"
                :class="[{ 'visual-pointer__item_theme_floor': pointer.floor },
                 {'is-hovered': pointer.isHovered},
                 'visual-pointer__item']"
                :key=index
                :id=pointer.id
                :style="{ top: pointer.reposition.top, left: pointer.reposition.left}"
                ref="pointers"
            >{{pointer.text}}</div>
        </template>
    </div>
</template>

<style lang='scss'>
    @import "./Pointer.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import reposition from '../../helpers/reposition';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    computed: {
        ...mapGetters({
            renderSize: 'GET_CANVAS_SIZE',
            pointers  : 'GET_POINTERS',
            rotate    : 'GET_ROTATE'
        })
    },

    methods: {
        ...mapActions(['changePosition']),

        /**
         * Метод позиционирует поинтеры согласно координатам svg-якорей.
         */
        position() {
            if (this.pointers && this.pointers.length) {
                const coords = reposition(this.$refs.anchor);

                this.changePosition({
                    type: 'pointers',
                    coords
                });
            }
        },

        subscribes() {
            observer.subscribe('setPointerHover', (id) => {
                if (this.pointers && this.pointers.length) {
                    // eslint-disable-next-line array-callback-return
                    this.pointers.forEach((pointer) => {
                        if (pointer.id === id) {
                            pointer.isHovered = true;
                        }
                    });
                }
            });

            observer.subscribe('removePointerHover', (id) => {
                if (this.pointers && this.pointers.length) {
                    // eslint-disable-next-line array-callback-return
                    this.pointers.forEach((pointer) => {
                        if (pointer.id === id) {
                            pointer.isHovered = false;
                        }
                    });
                }
            });
        }
    },

    watch: {
        rotate() {
            this.$nextTick(() => {
                this.position();
            });
        }
    },

    mounted() {
        this.position();
        if (!Utils.isBreakpoint(0, 1280)) {
            this.subscribes();
        }

        window.addEventListener('resize', this.position);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.position);
    }
};
</script>
